export const SELECTION_TYPE_PARAMS = {
  fields: {
    AttendeeType: [
      "active_attendees_count",
      "age_grade_restriction_unit",
      "age_restrictions",
      "age_restriction_phrase",
      "age_restriction_unit",
      "allow_deposit",
      "can_be_deleted",
      "collection_options",
      "contextual_date_time",
      "confirmation_email_message",
      "currency",
      "currency_symbol",
      "evaluate_age_at",
      "event_start_date",
      "gender_options",
      "gender_restrictions",
      "gender_restriction_unit",
      "grade_label",
      "grade_label_options",
      "grade_options",
      "grade_restrictions",
      "grade_restriction_phrase",
      "has_custom_genders",
      "max_age",
      "max_grade",
      "min_age",
      "minimum_deposit_formatted",
      "min_grade",
      "maximum_capacity",
      "minimum_deposit_cents",
      "name",
      "publicly_available",
      "personal_collection_option_attributes",
      "position",
      "price_cents",
      "price_formatted",
      "signup_time",
      "template_attendee_type",
      "waitlist",
      "waitlist_attendees_count"
    ].join(",")
  }
}

export const SIGNUP_PARAMS = {
  fields: {
    Event: [
      "maximum_capacity",
      "maximum_registration_attendees",
      "event_times",
      "registration_type",
      "active_attendees_count",
      "first_event_date",
      "has_attendees_module",
      "has_payments_module",
      "register_for_separate_times",
      "can_change_register_for_separate_times",
      "event_start_date",
      "currency_symbol",
      "general_reminders_enabled"
    ].join(","),
    EventTime: ["contextual_date_time", "available_for_registrations", "starts_at", "ends_at"].join(
      ","
    )
  },
  include: ["event_times"]
}
